/* eslint-disable jira/filename-case */
export const GIRA_APOLLO_CLIENT = 'gira';
